/**
 * About Planapus — bottom-of-page founder paragraph, rebuilt with Oatmeal
 * primitives (Container, Eyebrow, Text, hairline border). The brand-v2
 * AppModuleBlock graphic is retired; the section is purely typographic
 * in the Oatmeal aesthetic.
 */

import React from 'react';
import {Container} from '../../oatmeal/elements/container';
import {Eyebrow} from '../../oatmeal/elements/eyebrow';
import {Text} from '../../oatmeal/elements/text';
import {usePilot} from './PilotContext';

export default function PilotAbout() {
  const {viewMode} = usePilot();
  // F17 Slice D: was hidden in pitch/demo/vision modes by
  // `body.X-mode .mp-about-subtle` CSS rules. Now React-state driven.
  const isStoryMode = viewMode === 'story' || viewMode === 'sandbox';
  return (
    <section
      className="mp-about-subtle border-t border-taupe-200 py-16 dark:border-taupe-800"
      hidden={!isStoryMode}
    >
      <Container className="flex flex-col gap-6">
        <Eyebrow>About Planapus</Eyebrow>
        <Text className="max-w-2xl">
          Planapus is building the AI-native coordination layer for the
          enterprise. The founders built and led the agreement platform and
          extensibility at Docusign and observed the same pattern across
          industries: documents got signed, but the work around them stayed
          broken. Vendor onboarding, employee service requests and
          exceptions, financial services account opening, government
          applications &mdash; hampered by errors, delays, downstream costs.
          Planapus turns that work into smooth operations, coordinated by AI.
        </Text>
      </Container>
    </section>
  );
}
